import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  MenuItem,
  Pagination,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import TableGeneric from "../../components/Generics/TableGeneric";
import { GridColDef, GridSortModel } from "@mui/x-data-grid";
import { formatarData, useIsSmallScrenn } from "../../helper";
import { useSnack } from "../../redux/snack/snackHooks";
import Titulo2 from "../../components/Generics/Titulo2";
import VisibilityIcon from "@material-ui/icons/Visibility";
import movimentacaoManutencaoApi from "../../api/movimentacaoManutencaoApi";
import ModalInfoMovimentacaoManutencao from "../../components/modais/ModalInfoMovimentacaoManutencao";
import { DadosMovimentacaoManutencao } from "../../model/entities/ProgramaManutencao";
import LoadingBackdrop from "../../components/Generics/LoadingBackdrop";
import GridCenter from "../../components/Generics/GridCenter";
import dayjs from "dayjs";
import MiniInfo from "../../components/Generics/MiniInfo";
import DatePickerGeneric from "../../components/Generics/DatePickerGeneric";
import FilterAltRoundedIcon from "@mui/icons-material/FilterAltRounded";
type Props = {};

const MovimentacaoEmManutencaoPage: React.FC<Props> = (props) => {
  const isSmallScrenn = useIsSmallScrenn();
  const [movimentacoes, setMovimentacoes] = useState<
    DadosMovimentacaoManutencao[]
  >([]);
  const [totalLinhas, setTotalLinhas] = useState(0);
  const [loading, setLoading] = useState(true);
  const [pagina, setPagina] = useState(1);
  const [linhasPorPagina, setLinhasPorPagina] = useState(0);
  const [movimentacaoSelecionada, setMovimentacaoSelecionada] =
    useState<DadosMovimentacaoManutencao | null>(null);
  const [openModal, setOpenModal] = useState(false);
  const mostrarSnack = useSnack();
  const rowHeight = 52;
  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: "dataHoraSolicitacao", sort: "desc" },
  ]);

  const [dataInicial, setDataInicial] = useState<dayjs.Dayjs>(
    dayjs().subtract(3, "month")
  );
  const [dataFinal, setDataFinal] = useState<dayjs.Dayjs>(dayjs());
  const [placaFiltro, setPlacaFiltro] = useState("");
  const [statusFiltro, setStatusFiltro] = useState<string>("");
  const [placaFiltroDigitado, setPlacaFiltroDigitado] = useState("");

  useEffect(() => {
    const calcularPageSize = () => {
      const alturaHeader = 56;
      const alturaFooter = 52;
      const alturaDisponivel =
        window.innerHeight - alturaHeader - alturaFooter - 380;
      const linhasVisiveis = Math.floor(alturaDisponivel / rowHeight);
      setLinhasPorPagina(linhasVisiveis > 0 ? linhasVisiveis : 10);
    };

    calcularPageSize();
    window.addEventListener("resize", calcularPageSize);

    return () => {
      window.removeEventListener("resize", calcularPageSize);
    };
  }, []);

  const buscarMovimentacoes = async () => {
    try {
      setLoading(true);

      let field = sortModel[0]?.field ?? "dataHoraSolicitacao";
      if (field === "dataMovimentacao") field = "dataHoraSolicitacao";

      const filtros = {
        dataInicial: dataInicial ? dataInicial.format("YYYY-MM-DD") : undefined,
        dataFinal: dataFinal ? dataFinal.format("YYYY-MM-DD") : undefined,
        placa: placaFiltro.trim() || undefined,
        status: statusFiltro || undefined,
      };

      const res = await movimentacaoManutencaoApi.getMany(
        pagina - 1,
        linhasPorPagina,
        field,
        sortModel[0]?.sort ?? "desc",
        filtros
      );
      console.log("res", res);
      setMovimentacoes(res.dados ?? res.movimentacoes ?? []);
      setTotalLinhas(res.total ?? 0);
    } catch (erro: any) {
      mostrarSnack(
        "Ops! Aconteceu um problema ao buscar as movimentações!",
        "error"
      );
      console.error("Erro ao buscar movimentações:", erro);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    buscarMovimentacoes();
  }, [pagina, linhasPorPagina, sortModel, placaFiltro]);

  const columns: GridColDef<DadosMovimentacaoManutencao>[] = [
    {
      field: "id",
      headerName: "ID",
      width: 50,
      editable: false,
    },
    {
      field: "dataMovimentacao",
      headerName: "Data da Movimentação",
      width: 180,
      editable: false,
      renderCell: (params) => {
        return formatarData(params.row.dataHoraSolicitacao.toString());
      },
    },
    {
      field: "placaVeiculo",
      headerName: "Placa do Veículo",
      width: 150,
      editable: false,
    },

    {
      field: "fornecedor",
      headerName: "Fornecedor",
      width: 150,
      editable: false,
    },

    {
      field: "previsaoConclusao",
      headerName: "Previsão de Conclusão",
      width: 180,
      editable: false,
    },

    {
      field: "statusMovimentacaoManutencao",
      headerName: "Status da Movimentação",
      width: 180,
      editable: false,
      renderCell: (params) => {
        const movimentacao = params.row;
        if (movimentacao.statusMovimentacaoManutencao === `EM_EXECUCAO`) {
          return <MiniInfo color="#283d9e">Em Execucao</MiniInfo>;
        } else if (movimentacao.statusMovimentacaoManutencao === `FINALIZADO`) {
          return <MiniInfo color="#398c08 ">Finalizado</MiniInfo>;
        }

        <>
          <IconButton onClick={(e) => e.stopPropagation()}>
            <VisibilityIcon
              color="primary"
              onClick={(e) => {
                e.stopPropagation();
                setMovimentacaoSelecionada(movimentacao);
                setOpenModal(true);
              }}
            />
          </IconButton>
        </>;
      },
    },

    {
      field: "acoes",
      headerName: "Ações",
      width: 80,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        const movimentacao = params.row;
        return (
          <>
            <IconButton onClick={(e) => e.stopPropagation()}>
              <VisibilityIcon
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  setMovimentacaoSelecionada(movimentacao);
                  setOpenModal(true);
                }}
              />
            </IconButton>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPlacaFiltro(placaFiltroDigitado);
    }, 2000);

    return () => clearTimeout(timeout);
  }, [placaFiltroDigitado]);

  if (loading) {
    return (
      <LoadingBackdrop
        open={loading}
        texto="Buscando movimentações dos veículos em manutenção . . ."
      />
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
        bgcolor: "background.default",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          overflow: "hidden",
          py: 2,
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Titulo2>Movimentações de manutenção</Titulo2>
        </Box>

        <Paper
          elevation={0}
          sx={{
            borderRadius: 3,
            p: 3,
            mb: 2,
            bgcolor: "background.paper",
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <Box display="flex" alignItems="center" gap={1} mb={2.5}>
            <FilterAltRoundedIcon color="primary" />
            <Typography variant="subtitle1" fontWeight={600}>
              Filtros de busca
            </Typography>
          </Box>

          <Box display="flex" justifyContent="flex-end">
            <Stack
              direction="row"
              spacing={2}
              flexWrap="wrap"
              justifyContent="flex-end"
            >
              <Box sx={{ width: { xs: "100%", sm: 200 } }}>
                <DatePickerGeneric
                  label="Data inicial"
                  value={dataInicial}
                  setValue={setDataInicial}
                />
              </Box>
              <Box sx={{ width: { xs: "100%", sm: 200 } }}>
                <DatePickerGeneric
                  label="Data final"
                  value={dataFinal}
                  setValue={setDataFinal}
                />
              </Box>
              <Box sx={{ width: { xs: "100%", sm: 200 } }}>
                <TextField
                  select
                  fullWidth
                  label="Status"
                  value={statusFiltro}
                  onChange={(e) => setStatusFiltro(e.target.value)}
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="EM_EXECUCAO">Em Execução</MenuItem>
                  <MenuItem value="FINALIZADO">Finalizado</MenuItem>
                </TextField>
              </Box>
              <Box sx={{ width: { xs: "100%", sm: 200 } }}>
                <TextField
                  fullWidth
                  label="Placa do veículo"
                  placeholder="Ex: ABC-1234"
                  value={placaFiltroDigitado}
                  onChange={(e) => setPlacaFiltroDigitado(e.target.value)}
                />
              </Box>
              <Button
                variant="contained"
                onClick={buscarMovimentacoes}
                sx={{
                  background:
                    "linear-gradient(90deg, #283d9e 0%, #4053b7 100%)",
                  borderRadius: 2,
                  px: 4,
                  py: 1.4,
                  fontWeight: 600,
                  fontSize: "15px",
                  textTransform: "none",
                  boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                  alignSelf: "flex-end",
                  "&:hover": {
                    background:
                      "linear-gradient(90deg, #1f2f7a 0%, #3347a1 100%)",
                    boxShadow: "0px 3px 10px rgba(0,0,0,0.15)",
                  },
                }}
              >
                Aplicar filtros
              </Button>
            </Stack>
          </Box>
        </Paper>

        <Box sx={{ flexGrow: 1, minHeight: 0 }}>
          {isSmallScrenn ? (
            <>
              {movimentacoes.map((movimentacao) => (
                <GridCenter key={movimentacao.id}>
                  <Paper
                    sx={{
                      my: 1,
                      p: 2,
                      width: "100%",
                      borderRadius: 2,
                    }}
                  >
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Typography fontWeight="bold">
                          ID {movimentacao.id} | {movimentacao.nomeUsuario}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>
                          Placa: {movimentacao.placaVeiculo}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>
                          Fornecedor: {movimentacao.fornecedor}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>
                          Tipo: {movimentacao.tipoMovimentacaoManutencao}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>
                          Solicitação:{" "}
                          {dayjs(movimentacao.dataHoraSolicitacao).format(
                            "DD/MM/YYYY - HH:mm"
                          )}
                        </Typography>
                      </Grid>
                      {movimentacao.previsaoConclusao && (
                        <Grid item xs={12}>
                          <Typography>
                            Previsão: {movimentacao.previsaoConclusao}
                          </Typography>
                        </Grid>
                      )}
                      <Grid item xs={12} textAlign="right">
                        <IconButton
                          onClick={() => {
                            setMovimentacaoSelecionada(movimentacao);
                            setOpenModal(true);
                          }}
                        >
                          <VisibilityIcon color="primary" />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Paper>
                </GridCenter>
              ))}

              <GridCenter>
                <Pagination
                  size="large"
                  defaultPage={1}
                  count={Math.ceil(totalLinhas / linhasPorPagina)}
                  onChange={(event, number) => setPagina(number)}
                  page={pagina}
                />
              </GridCenter>
            </>
          ) : (
            <TableGeneric
              pageSize={linhasPorPagina}
              colunas={columns}
              linhas={movimentacoes}
              loading={loading}
              totalLinhas={totalLinhas}
              selecionaLinha={false}
              paginaAtual={pagina - 1}
              formasDeListar={[10, 20, 50]}
              sx={{
                flexGrow: 1,
                height: "100%",
                "& .MuiDataGrid-virtualScroller": {
                  minHeight: "100%",
                },
              }}
              rowHeight={52}
              sortModel={sortModel}
              setSortModel={setSortModel}
              onRowClick={(params) => {
                setMovimentacaoSelecionada(params.row);
                setOpenModal(true);
              }}
              setPaginacao={(model) => {
                setPagina(model.page + 1);
                setLinhasPorPagina(model.pageSize);
              }}
            />
          )}
        </Box>
      </Container>

      {openModal && movimentacaoSelecionada && (
        <ModalInfoMovimentacaoManutencao
          open={openModal}
          dadosMovimentacao={movimentacaoSelecionada}
          onClose={() => {
            buscarMovimentacoes();
            setOpenModal(false);
            setMovimentacaoSelecionada(null);
          }}
        />
      )}
    </Box>
  );
};

export default MovimentacaoEmManutencaoPage;
